import axios from "axios";
import React, { useEffect, useState } from "react";
import { AmbikaChefAPI } from "./config";
import { useLocation, useNavigate } from "react-router-dom";
import { is } from "date-fns/locale";

const OrdrNav = ({ orderList, refreshOrders }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userSelectedTab, setUserSelectedTab] = useState(null);

  const isActiveLink = (link) => {
    return link === location.pathname;
  };
  // Map of orderList keys to their routes
  const routeMap = {
    orderPlace: "/order-place",
    acceptedOrder: "/accepted-order",
    sendForProduction: "/send-for-production",
    viewsendForProduction: "/send-for-production-list",
    productionReady: "/production-ready",
    pendingPacking: "/pending-packing",
    foodReady_report: "/food-ready-report",
    productionReady_report: "/production-ready-report",
    packingReady_report: "/packing-ready-report",
  };

  // Check if current route is valid (has items)
  const isCurrentRouteValid = () => {
    const currentTabKey = Object.keys(routeMap).find(
      (key) => routeMap[key] === location.pathname
    );
    return currentTabKey && orderList?.[currentTabKey]?.totCount > 0;
  };

  // Get first available tab with items
  const getFirstAvailableTab = () => {
    const firstNonZeroEntry = Object.entries(orderList || {}).find(
      ([key, value]) => value?.totCount > 0
    );
    return firstNonZeroEntry ? routeMap[firstNonZeroEntry[0]] : null;
  };

  useEffect(() => {
    // If no user selection OR current route is invalid (empty)
    if (!userSelectedTab || !isCurrentRouteValid()) {
      const firstAvailable = getFirstAvailableTab();
      if (firstAvailable && location.pathname !== firstAvailable) {
        navigate(firstAvailable);
      }
    }
  }, [orderList, location.pathname, navigate, userSelectedTab]);

  const handleTabClick = (route) => {
    setUserSelectedTab(route);
    navigate(route);
  };

  const scrollRight = () => {
    const container = document.querySelector(".orderOption");
    container.scrollBy({ left: 200, behavior: "smooth" });
  };

  const scrollLeft = () => {
    const container = document.querySelector(".orderOption");
    container.scrollBy({ left: -200, behavior: "smooth" });
  };
  return (
    <div>
      <div className="col-lg-6 col-md-8 col-11 m-auto ">
        <div className="d-flex align-items-center gap-2 mt-3 col-12 justify-content-between">
          <button
            class="btn btn-outline-success px-1 p-0 "
            onClick={scrollLeft}
          >
            <i class="bi bi-arrow-left-short"></i>
          </button>
          <div class="  orderOption ">
            {orderList?.orderPlace?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/order-place")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("order-place")}
              >
                <p class="text-nowrap">{orderList?.orderPlace?.name}</p>
                <div class="orderNotification">
                  {orderList?.orderPlace?.totCount}
                </div>
              </div>
            )}
            {orderList?.acceptedOrder?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/accepted-order")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("accepted-order")}
              >
                <p class="text-nowrap">{orderList?.acceptedOrder?.name}</p>
                <div class="orderNotification">
                  {orderList?.acceptedOrder?.totCount}
                </div>
              </div>
            )}
            {orderList?.sendForProduction?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/send-for-production")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("send-for-production")}
              >
                <p class="text-nowrap">{orderList?.sendForProduction?.name}</p>
                <div class="orderNotification">
                  {orderList?.sendForProduction?.totCount}
                </div>
              </div>
            )}
            {orderList?.viewsendForProduction?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/send-for-production-list")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("send-for-production-list")}
              >
                <p class="text-nowrap">
                  {orderList?.viewsendForProduction?.name}
                </p>
                <div class="orderNotification">
                  {orderList?.viewsendForProduction?.totCount}
                </div>
              </div>
            )}
            {orderList?.productionReady?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/production-ready")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("production-ready")}
              >
                <p class="text-nowrap">{orderList?.productionReady?.name}</p>
                <div class="orderNotification">
                  {orderList?.productionReady?.totCount}
                </div>
              </div>
            )}
            {orderList?.pendingPacking?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/pending-packing")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("pending-packing")}
              >
                <p class="text-nowrap">{orderList?.pendingPacking?.name}</p>
                <div class="orderNotification">
                  {orderList?.pendingPacking?.totCount}
                </div>
              </div>
            )}
            {orderList?.foodReady_report?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/food-ready-report")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("food-ready-report")}
              >
                <p class="text-nowrap">{orderList?.foodReady_report?.name}</p>
                <div class="orderNotification">
                  {orderList?.foodReady_report?.totCount}
                </div>
              </div>
            )}
            {orderList?.productionReady_report?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/production-ready-report")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("production-ready-report")}
              >
                <p class=" text-nowrap">
                  {orderList?.productionReady_report?.name}
                </p>
                <div class="orderNotification">
                  {orderList?.productionReady_report?.totCount}
                </div>
              </div>
            )}
            {orderList?.packingReady_report?.totCount !== 0 && (
              <div
                class="orderOptiondiv"
                style={
                  isActiveLink("/packing-ready-report")
                    ? {
                        color: "#1a8855",
                        fontWeight: "bold",
                        borderBottom: "2px solid #1a8855",
                      }
                    : { color: "black", fontWeight: "normal" }
                }
                onClick={() => handleTabClick("packing-ready-report")}
              >
                <p class="text-nowrap">
                  {orderList?.packingReady_report?.name}
                </p>
                <div class="orderNotification">
                  {orderList?.packingReady_report?.totCount}
                </div>
              </div>
            )}
          </div>

          <button
            class="btn btn-outline-success px-1 p-0"
            onClick={scrollRight}
          >
            <i class="bi bi-arrow-right-short"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrdrNav;
